import React from 'react';
import PropTypes from 'prop-types';
import Field from 'redux-form/es/Field';
import reduxForm from 'redux-form/es/reduxForm';
import InputSelectField from 'components/Credit24/Core/Controls/InputSelectField';

const propTypes = {
  accountYears: PropTypes.array,
  selectorDisabled: PropTypes.bool,
  handleSubmit: PropTypes.func,
};

const StatementOfAccountForm = ({ accountYears, selectorDisabled, handleSubmit }) => (
  <form onSubmit={handleSubmit}>
    <Field
      name="accountYear"
      component={InputSelectField}
      options={accountYears}
      disabled={selectorDisabled}
      emptyTextKey="selfservice.statementOfAccount.year"
      isFullWidth
    />
  </form>
);

const statementOfAccountFormConfig = {
  form: 'statementOfAccountForm',
  initialValues: {
    accountYear: new Date().getFullYear().toString(),
  },
  onSubmitFail: (error) => {
    if (DEBUG) {
      console.warn('form submit fail', error);
    }
  },
};

StatementOfAccountForm.propTypes = propTypes;

export default reduxForm(statementOfAccountFormConfig)(StatementOfAccountForm);
